import React from "react";

function SkeletonRow() {
	return (
		<div className="flex animate-pulse gap-3 px-4 py-2">
			<div className="tailwick-ticket-item__avatar size-9 shrink-0 rounded-full" />
			<div className="min-w-0 flex-1 space-y-2 pt-0.5">
				<div className="h-3.5 w-2/5 rounded bg-default-200" />
				<div className="h-3 w-3/5 rounded bg-default-150" />
			</div>
			<div className="h-3 w-8 shrink-0 rounded bg-default-150" />
		</div>
	);
}

/**
 * Skeleton da lista de conversas no padrão Tailwick (sem MUI).
 */
export default function ChatTailwickListSkeleton() {
	return (
		<div className="py-2" aria-hidden>
			<SkeletonRow />
			<SkeletonRow />
			<SkeletonRow />
		</div>
	);
}
